import moment from 'moment';
import PropTypes from 'prop-types';
import { types, fieldTypes, personFieldTypes } from '@actions/conference';
import { types as trscTypes } from '@actions/trscService';
import { addUnique } from '@services/unique';
import { PERSON_TYPES } from '@config/authentication';

export const DEFAULT_LANGUAGE = 'en-US';

export const personType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string,
  country: PropTypes.string,
  timezone: PropTypes.string,
  email: PropTypes.string,
  conferencePhoneNumberId: PropTypes.number,
});

export const defaultClient = {
  name: '',
  type: PERSON_TYPES.SPECIALIST,
  phoneNumber: '',
  country: '',
  timezone: moment().format('Z'),
  email: '',
};

export const initialState = {
  tags: [],
  callAudio: null,
  conferenceCallUuid: '',
  [fieldTypes.DATE]: moment()
    .seconds(0)
    .format('YYYY-MM-DDTHH:mm:ssZ'),
  errors: {
    title: undefined,
  },
  [fieldTypes.CREATE_TRANSCRIPT]: false,
  [fieldTypes.USE_TWO_FACTOR_AUTH]: false,
  id: undefined,
  isDialogOpen: false,
  isFetching: false,
  isFinishing: false,
  isPublished: false,
  isPublishing: false,
  isSubmitting: false,
  edited: false,
  isRequestingHumanTranscript: false,
  isHumanTranscriptRequested: false,
  language: DEFAULT_LANGUAGE,
  people: [{ ...defaultClient }],
  [fieldTypes.TITLE]: '',
  pin: '',
  isRegenerating: false,
  locale: 'en_GB',
  [fieldTypes.ANALYST]: undefined,
  [fieldTypes.INTRO_MESSAGE]: null,
  requestedTranscriptId: null,
  clientReference: '',
  projectCode: '',
  specialistNumber: '',
  [fieldTypes.ORGANIZATION]: null,
  expandedId: null,
  transcriptId: null,
  isAITranscriptNeeded: false,
  isTranscriptNeeded: false,
};

export default function reducerConferenceFor(type = '') {
  return function reducer(state = initialState, action = {}) {
    switch (action.type) {
      case type + types.ADD_PERSON:
        return {
          ...state,
          people: [...state.people, { ...defaultClient }],
        };
      case type + types.REMOVE_PERSON:
        return {
          ...state,
          people: state.people.filter((_, id) => id !== action.id),
        };
      case type + types.RESET:
        return initialState;
      case type + types.ADD_TAG: {
        const tag = action.tag.trim();
        if (tag) {
          return {
            ...state,
            tags: addUnique(state.tags, tag),
          };
        }
        return state;
      }
      case type + types.DELETE_TAG:
        return {
          ...state,
          tags: state.tags.filter((tag) => tag !== action.tag),
        };
      case type + types.SET.FIELD:
        if (!Object.values(fieldTypes).includes(action.field)) {
          return state;
        }
        return {
          ...state,
          [action.field]: action.value,
          edited: true,
        };
      case type + types.SET.PERSON_FIELD:
        if (!Object.values(personFieldTypes).includes(action.field)) {
          return state;
        }
        return {
          ...state,
          edited: true,
          people: state.people.map((person, i) => {
            return i === action.id ? { ...person, [action.field]: action.value } : person;
          }),
        };
      case type + types.SET.CALL_AUDIO:
        return {
          ...state,
          callAudio: action.file,
        };
      case type + types.GET_TRANSCRIPT_ENTRY_BY_ID: {
        const { id } = action;
        return {
          ...state,
          requestedTranscriptId: id,
          isFetching: true,
        };
      }
      case type + types.GET_BY_LINKS_UUID.STARTED:
      case type + types.GET_BY_ID.STARTED:
        return {
          ...state,
          isFetching: true,
        };
      case type + types.GET_BY_LINKS_UUID.SUCCESS:
        return {
          ...state,
          ...action.transcript,
          isFetching: false,
        };
      case type + types.GET_BY_ID.SUCCESS:
        return {
          ...initialState,
          ...action.conference,
          isFetching: false,
        };
      case type + types.GET_BY_LINKS_UUID.FAILURE:
      case type + types.GET_BY_ID.FAILURE:
        return {
          ...state,
          isFetching: false,
        };
      case type + types.CREATE_CONFERENCE.STARTED:
      case type + types.UPDATE_CONFERENCE.STARTED:
      case type + types.INSERT.STARTED:
        return {
          ...state,
          isSubmitting: true,
        };
      case type + types.CREATE_CONFERENCE.SUCCESS:
      case type + types.UPDATE_CONFERENCE.SUCCESS:
      case type + types.INSERT.SUCCESS:
        return {
          ...(state.edited ? state : initialState),
          isSubmitting: false,
          edited: false,
        };
      case type + types.CREATE_CONFERENCE.FAILURE:
      case type + types.UPDATE_CONFERENCE.FAILURE:
      case type + types.INSERT.FAILURE:
        return {
          ...state,
          isSubmitting: false,
          edited: false,
          errors: {
            ...action.errors,
          },
        };
      case type + types.REGENERATE_PIN.STARTED:
        return {
          ...state,
          isRegenerating: true,
        };
      case type + types.REGENERATE_PIN.SUCCESS:
        return {
          ...state,
          pin: action.pin,
          pinId: action.pinId,
          isRegenerating: false,
        };
      case type + types.REGENERATE_PIN.FAILURE:
        return {
          ...state,
          isRegenerating: false,
        };
      case type + types.REQUEST_HUMAN_TRANSCRIPT.STARTED:
        return {
          ...state,
          isRequestingHumanTranscript: true,
        };
      case type + types.REQUEST_HUMAN_TRANSCRIPT.SUCCESS:
        return {
          ...state,
          isRequestingHumanTranscript: false,
        };
      case type + types.REQUEST_HUMAN_TRANSCRIPT.FAILURE:
        return {
          ...state,
          isRequestingHumanTranscript: false,
        };
      case types.SET.LANGUAGE:
      case type + types.SET.LANGUAGE:
        return {
          ...state,
          language: action.language,
          languagePrefs: action.languagePrefs,
        };
      default:
        return state;
    }
  };
}



// WEBPACK FOOTER //
// ./redux/reducers/conference.js